import { useMediaQuery } from "react-responsive";

import { useFeatureFlags } from "@jti/commerce";
import { BREAKPOINT_LARGE } from "@jti/fe-common";

import { SubscriptionSummary } from "@checkout-v2/features";
import { DiscountDisclaimerContainer } from "@checkout-v2/features/DiscountDisclaimer";
import { CartItemsSummaryContainer } from "@checkout-v2/features/ItemsSummary";
import { LoyaltyReferralCodeContainer } from "@checkout-v2/features/LoyaltyReferralCode";
import { CartPaymentSummaryContainer } from "@checkout-v2/features/PaymentSummary";
import { PromoCodeContainer } from "@checkout-v2/features/PromoCode";
import { CheckoutPromoGiftsContainer } from "@checkout-v2/features/PromoGifts";

export const CheckoutSidebar = () => {
  const isDesktopView = useMediaQuery({ minWidth: BREAKPOINT_LARGE });
  const { ffCheckoutV2EnableIteration2 } = useFeatureFlags();

  return (
    <>
      {isDesktopView && !ffCheckoutV2EnableIteration2 && <CartItemsSummaryContainer />}

      <DiscountDisclaimerContainer />
      <LoyaltyReferralCodeContainer />
      <PromoCodeContainer />
      <CheckoutPromoGiftsContainer />
      <CartPaymentSummaryContainer />
      <SubscriptionSummary />
    </>
  );
};
